import styled from 'styled-components';
import { theme } from '@Themes/themeOverriderFabric';
import { getBaseTheme } from '@Themes';

export const SwitchButton = styled.button`
    flex: 1;
    margin: 0;
    width: 6.75rem;
    height: inherit;
    font-size: ${getBaseTheme().texts.sizes.xs.fontSize};
    font-family: ${getBaseTheme().texts.fonts.default.family};
    border: ${`1px solid ${theme.palette.gray}`};
    border-radius: ${props => (props.active ? '0.2rem' : '0.2rem 0 0 0.2rem')};
    color: ${props => (props.active ? `${theme.palette.darkText}` : `${theme.palette.grayDark}`)};
    background: ${props => (props.active ? `${theme.palette.white}` : `${theme.palette.gray}`)};
    cursor: pointer;
`;
export const SwitchButtonWrapper = styled.div`
    flex: 1;
    display: flex;
    height: 3.4rem;
    border-radius: 0.2rem;
    background: ${theme.palette.gray};
`;
